export default {"src":"/_next/static/media/LeftArrow.26ea9278.svg","height":33,"width":33};